"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/table/style/css");
var table_1 = __importDefault(require("antd/lib/table"));
require("antd/lib/space/style/css");
var space_1 = __importDefault(require("antd/lib/space"));
require("antd/lib/tooltip/style/css");
var tooltip_1 = __importDefault(require("antd/lib/tooltip"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
require("antd/lib/modal/style/css");
var modal_1 = __importDefault(require("antd/lib/modal"));
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var PageQR_1 = __importDefault(require("./PageQR"));
var pages_1 = require("../../hooks/pages");
var utils_1 = require("../../utils");
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var QRModal = /*#__PURE__*/ react_1.default.memo(function (_ref) {
    var page = _ref.page, modalCancel = _ref.modalCancel;
    return (0, jsx_runtime_1.jsx)(modal_1.default, {
        title: page === null || page === void 0 ? void 0 : page.title,
        style: {
            top: 36
        },
        open: !!page,
        onCancel: modalCancel,
        footer: null,
        children: page ? (0, jsx_runtime_1.jsx)(PageQR_1.default, {
            page: page
        }) : null
    });
});
var PageListView = /*#__PURE__*/ react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var pagesInitialFetch = (0, react_redux_1.useSelector)(function (state) {
        return state.pages.initialFetchDone;
    });
    var pagesFetching = (0, react_redux_1.useSelector)(function (state) {
        return state.pages.isFetching;
    });
    var pages = (0, react_redux_1.useSelector)(function (state) {
        return state.pages.items;
    });
    var _useState = (0, react_1.useState)(null), _useState2 = _slicedToArray(_useState, 2), qrPage = _useState2[0], setQrPage = _useState2[1];
    var columns = (0, react_1.useMemo)(function () {
        return [{
                title: "Title",
                dataIndex: "title"
            }, {
                title: "Enabled",
                dataIndex: "enabled",
                shouldCellUpdate: function shouldCellUpdate(r, pr) {
                    return (r === null || r === void 0 ? void 0 : r.enabled) !== (pr === null || pr === void 0 ? void 0 : pr.enabled);
                },
                render: function render(v) {
                    return v ? (0, jsx_runtime_1.jsx)(icons_1.CheckOutlined, {}) : (0, jsx_runtime_1.jsx)(icons_1.CloseOutlined, {});
                }
            }, {
                title: "Last Modified",
                sorter: function sorter(a, b) {
                    return new Date(a.revision.timestamp) - new Date(b.revision.timestamp);
                },
                render: function render(page) {
                    return (0, utils_1.timestampToString)(page.revision.timestamp);
                }
            }, {
                title: "Actions",
                key: "actions",
                shouldCellUpdate: function shouldCellUpdate(r, pr) {
                    return (r === null || r === void 0 ? void 0 : r.id) !== (pr === null || pr === void 0 ? void 0 : pr.id);
                },
                render: function render(page) {
                    return (0, jsx_runtime_1.jsxs)(space_1.default, {
                        size: "small",
                        children: [(0, jsx_runtime_1.jsx)(tooltip_1.default, {
                                title: "Show QR Code",
                                children: (0, jsx_runtime_1.jsx)(button_1.default, {
                                    icon: (0, jsx_runtime_1.jsx)(icons_1.QrcodeOutlined, {}),
                                    onClick: function onClick() {
                                        return setQrPage(page);
                                    }
                                })
                            }), (0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.EyeOutlined, {}),
                                onClick: function onClick() {
                                    return navigate("/pages/detail/".concat(page.id));
                                },
                                children: "View"
                            }), (0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}),
                                onClick: function onClick() {
                                    return navigate("/pages/edit/".concat(page.id));
                                },
                                children: "Edit"
                            })]
                    });
                }
            }];
    }, [navigate]);
    var modalCancel = (0, react_1.useCallback)(function () {
        return setQrPage(null);
    }, []);
    var pagination = (0, pages_1.useUrlPagination)();
    return (0, jsx_runtime_1.jsxs)(page_header_1.default, {
        ghost: false,
        title: "Pages",
        subTitle: "View and edit app pages",
        children: [(0, jsx_runtime_1.jsx)(QRModal, {
                page: qrPage,
                modalCancel: modalCancel
            }), (0, jsx_runtime_1.jsx)(table_1.default, {
                bordered: true,
                size: "small",
                loading: !pagesInitialFetch && pagesFetching,
                columns: columns,
                dataSource: pages,
                rowKey: "id",
                pagination: pagination
            })]
    });
});
exports.default = PageListView;
